import {isSafari, scrollToPosition} from "../utils/Utils.js";

const SectionScrolling = () => {

	const sections = document.querySelectorAll('' +
		'.singlepost .block-content > *:not(p):not(h1):not(h2):not(h3):not(h4):not(h5):not(h6)' +
		',' +
		'#the-footer' +
		',' +
		'.insurances-in-focus .intro-categories'
	);

	// Function to scroll to the next section
	const scrollToSection = (direction) => {
		// Get the current section
		const currentSection = Array.from(sections).findIndex((section) => {
			return section.getBoundingClientRect().top >= 0;
		});

		let nextSectionIndex;

		// Calculate the index of the next section based on the direction
		if(direction === 'ArrowDown') {
			nextSectionIndex = currentSection + 1;
		}
		else if(direction === 'ArrowUp') {
			nextSectionIndex = currentSection - 1;
		}

		// Scroll to the next section if it exists
		if(sections[nextSectionIndex]) {

			if(isSafari) {
				const nextSection = sections[nextSectionIndex];
				const targetPosition = nextSection.getBoundingClientRect().top + window.scrollY;
				scrollToPosition(targetPosition, 500);
			}
			else {
				sections[nextSectionIndex].scrollIntoView({
					behavior: 'smooth',
				});
			}
		}
	};

	// Event listener for arrow key presses
	document.addEventListener('keydown', (e) => {
		if(e.key === 'ArrowDown' || e.key === 'ArrowUp') {
			e.preventDefault();
			scrollToSection(e.key);
		}
	});
};

export default SectionScrolling;
